import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function LegalLayout({ title, updated, intro, sections }) {
  return (
    <div className="min-h-screen bg-white text-[#0F172A]" data-testid="legal-page">
      <Navbar />
      <section className="bg-[#26395F] text-white">
        <div className="max-w-4xl mx-auto px-6 py-16">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-white transition-colors" data-testid="legal-back-link">
            <ArrowLeft className="h-4 w-4" /> Back to home
          </Link>
          <h1 className="font-display text-4xl sm:text-5xl tracking-tight uppercase mt-6">{title}</h1>
          {updated && <p className="text-white/50 text-sm mt-3">Last updated: {updated}</p>}
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-6 py-16">
        {intro && <p className="text-[#334155] leading-relaxed mb-10">{intro}</p>}
        <div className="space-y-10">
          {sections.map((s, i) => (
            <div key={i}>
              <h2 className="font-display text-xl tracking-tight uppercase text-[#0F172A]">{i + 1}. {s.heading}</h2>
              <div className="text-[#334155] leading-relaxed mt-3 space-y-3">
                {s.body.map((p, j) => <p key={j}>{p}</p>)}
              </div>
            </div>
          ))}
        </div>
        <p className="text-sm text-[#94A3B8] mt-12 border-t border-[#E2E8F0] pt-6">
          Questions? Reach us at{" "}
          <a href="mailto:akarjagdev@gmail.com" className="text-[#3B82F6] font-medium hover:underline">akarjagdev@gmail.com</a>{" "}
          or call{" "}
          <a href="tel:+18644810776" className="text-[#3B82F6] font-medium hover:underline">(864) 481-0776</a>.
        </p>
      </section>
      <Footer />
    </div>
  );
}
